/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:49:44
 *
 *******************************************************/
// @flow

// Display 10 item per page
export const NUMBER_SWATCHES_PER_PAGE = 10;

export const OPTION_DISPLAY_TYPES = [
  { value: 'oneColor', label: 'AdminHTML.SwatchSettings.Constants.optionDisplay_OneColor' },
  { value: 'twoColors', label: 'AdminHTML.SwatchSettings.Constants.optionDisplay_TwoColors' },
  { value: 'image', label: 'AdminHTML.SwatchSettings.Constants.optionDisplay_Image' }
];
